
import React from 'react';
import { toast } from 'react-toastify';
import './customToast.css'; // Import your custom CSS file

const CustomToast = ({ title, message }) => (
    <div className="custom-success-toast">
        <div className="toast-message">
            <span className="toast-title">{title}</span>
            <span className="toast-text">{message}</span>
        </div>
    </div>
);

const showSuccessToast = (message) => {
    toast.success(<CustomToast title="Success Alert" message={message} />);
};

export { showSuccessToast };
